import { closeSubcontractorDrawer } from '../State/subcontractorDrawer'

export default () => (dispatch) => {

  dispatch(closeSubcontractorDrawer())

}
